import React from 'react';
import { robotIcon } from '../chatIcons';
import './AssistantBotRow.css';

export type AssistantBotRowVariant = 'default' | 'error';

export interface AssistantBotRowProps {
  children: React.ReactNode;
  /** Error styling for assistant system messages */
  variant?: AssistantBotRowVariant;
  className?: string;
  /** Fade/slide-in when the row mounts (chat thread pacing). */
  animateIn?: boolean;
}

/**
 * Assistant message row with robot avatar — same visual language as General Profile chat.
 * Use in definition-driven document chats (worker registry, future forms).
 */
const AssistantBotRow: React.FC<AssistantBotRowProps> = ({
  children,
  variant = 'default',
  className,
  animateIn,
}) => {
  const isError = variant === 'error';
  const rowClass = ['wr-assistant-row', animateIn ? 'wr-assistant-row--enter' : '', className ?? '']
    .filter(Boolean)
    .join(' ');
  return (
    <div className={rowClass}>
      <div className="wr-assistant-row__avatar-wrap" aria-hidden>
        <img src={robotIcon} alt="" className="wr-assistant-row__avatar" />
      </div>
      <div
        className={
          isError
            ? 'wr-assistant-row__bubble-wrap wr-assistant-row__bubble-wrap--error'
            : 'wr-assistant-row__bubble-wrap'
        }
      >
        <div className={isError ? 'wr-assistant-row__bubble wr-assistant-row__bubble--error' : 'wr-assistant-row__bubble'}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AssistantBotRow;
